import React from "react";
import { observer } from "mobx-react-lite";
import CloudBackground from "../shared/components/CloudBackground";
import EventCodeInput from "./components/EventCodeInput";
import SitchLogo from "../shared/components/SitchLogo";
import EventCodeStore from "./store/eventCodeStore";
import EventStore from "../event/store/eventStore";
import GuestListStore from "../guest-list/store/guestListStore";
import communityNavigationStore, {
  CommunityView,
} from "../navigation/communityNavigationStore";

interface EventCodePageProps {
  eventGuid: string;
}

const EventCodePage: React.FC<EventCodePageProps> = observer(
  ({ eventGuid }) => {
    const handleSubmitEventCode = async () => {
      const authSuccess = await EventCodeStore.submitEventCode(eventGuid);
      if (authSuccess) {
        try {
          await EventStore.loadEventData(eventGuid);
          await GuestListStore.loadAttendees(eventGuid);
          communityNavigationStore.markEventAuthenticated(eventGuid);
          communityNavigationStore.navigateTo(CommunityView.EVENT_PAGE);
        } catch (err) {
          EventCodeStore.error = "Failed to load event data. Please try again.";
        }
      }
    };

    return (
      <CloudBackground>
        <div className="min-h-screen flex flex-col items-center px-6 pt-8 sm:pt-12">
          <div className="w-full max-w-md space-y-8">
            <SitchLogo />

            <div className="text-leading space-y-1">
              <h2 className="text-5xl font-nostalgic text-white leading-tight">
                Welcome to
              </h2>
              <h2 className="text-5xl font-nostalgic text-white leading-tight">
                Sitch Matchmaking
              </h2>
            </div>

            <div className="space-y-6">
              <h3 className="text-2xl text-white text-leading font-nostalgic">
                Enter your event code
              </h3>
              <EventCodeInput
                value={EventCodeStore.eventCode}
                onChange={EventCodeStore.setEventCode}
                onSubmit={handleSubmitEventCode}
              />
              {EventCodeStore.error && (
                <p className="mt-2 text-red-200 text-sm text-center">
                  {EventCodeStore.error}
                </p>
              )}
            </div>
          </div>
        </div>
      </CloudBackground>
    );
  },
);

export default EventCodePage;
